module.exports = __webpack_public_path__ + "static/media/footer.3f7a6b4a.svg";